import type { ReactNode } from 'react'

import React from 'react'

import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'

export type ActionType = {
	key: string
	label: string
	icon: ReactNode
	variant?: 'destructive'
	onClick: (props: { close: () => void }) => void
	disabled?: boolean
	testId: string
}

type SettingsActionDropdownProps = {
	side?: 'bottom' | 'top' | 'left' | 'right'
	align?: 'start' | 'center' | 'end'
	children: React.ReactElement & {
		ref?: React.Ref<HTMLElement>
	}
	actions: ActionType[]
}

export function ActionsDropdown({
	side = 'bottom',
	align = 'end',
	children,
	actions,
}: SettingsActionDropdownProps) {
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
			<DropdownMenuContent side={side} align={align}>
				{actions?.map(
					({ onClick, icon, label, variant, disabled = false }, i) => (
						<DropdownMenuItem
							key={`${label}_${i}`}
							onClick={() => onClick({ close })}
							variant={variant}
							disabled={disabled}
						>
							{icon}
							{label}
						</DropdownMenuItem>
					)
				)}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
